<template>
  <v-sheet height="56">
    <v-toolbar fixed flat :style="headerStyle">
      <v-btn fab text x-small color="black" @click="goBack">
        <v-icon size="24">mdi-arrow-left</v-icon>
      </v-btn>
      <!-- 페이지 제목 -->
      <v-toolbar-title></v-toolbar-title>
      <!-- 태그를 지우면 가운데 제목이 우측으로 이동 -->
      <v-toolbar-title
        class="bold"
        v-if="cancelBtnShow"
        @click="cancelApplication"
        >취소</v-toolbar-title
      >
    </v-toolbar>
  </v-sheet>
</template>
<script>
import routerNames from '@/const/routerConstants';
import { callApp } from '@/utils/app/callApp.js';

export default {
  data: () => ({}),
  computed: {
    headerStyle() {
      const pageName = this.$route.name;
      if (pageName === routerNames.WorkTimeSta) {
        return `background-color: #def6e5`;
      } else if (pageName === routerNames.AnnualHolidaySta) {
        return `background-color: #daecfe`;
      } else if (pageName === routerNames.MaternityHolidaySta) {
        return `background-color: #ffe8ec`;
      } else if (pageName === routerNames.WorkOverTimeSta) {
        return `background-color: #b5b9c2`;
      } else if (pageName === routerNames.CertiSta) {
        return `background-color: #d4deff`;
      } else {
        return ``;
      }
    },
    cancelBtnShow() {
      return this.$route.meta.cancelBtn;
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    cancelApplication() {
      callApp.keyboardDown();
      setTimeout(() => {
        if (
          confirm(
            '작성중인 신청서를 취소하시겠습니까? 작성한 내용은 사라집니다.',
          )
        ) {
          this.$store.commit('ELA/RESET_APPLICATION_STATE');
          this.$router.push(routerNames.Main);
        }
      }, 100);
    },
  },
};
</script>
<style></style>
